'use client'

import { useEffect } from 'react'
import { waitForAnalyticsLoad, identifyEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useUserContext } from '@context/UserContext/UserContenxt'
import logger from '@utils/logger'

const useIdentifyEvent = () => {
  // we call identify even t and pass properties as {} because we are not updating user properties
  // this is needed to be done because of the way segment works i.e.
  // for other events like track or view segments internally sends user_id
  // to send that user_id we need to call identifyEvent
  const { isLoggedIn } = useUserContext()
  useEffect(() => {
    if (isLoggedIn) {
      waitForAnalyticsLoad()
        .then(() => {
          identifyEvent({})
            .then(() => {})
            .catch(err => {
              logger.info('identifyEvent error', err)
            })
        })
        .catch(err => {
          logger.info('waitForAnalyticsLoad error', err)
        })
    }
  }, [isLoggedIn])
}

export default useIdentifyEvent
